import { inject, Injectable } from '@angular/core';

import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseService {
  protected readonly httpService = inject(HttpService);

  protected readonly baseRoute: string;

  protected constructor(baseRoute: string) {
    this.baseRoute = baseRoute;
  }

  protected get apiUrl() {
    return this.baseRoute;
  }
}
